import { getApiActionTypes } from '../../../shared/store/storeHelpers';

export const fetchManualAdjustmentReportDataTypes = getApiActionTypes(
  'CONSOLIDATION/MANUAL_ADJUSTMENT_REPORT/FETCH_REPORT_DATA',
);
